import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ModelFunctionsService } from './model-functions.service';

@Injectable()
export class ModelFunctionDeletionService {
  public deleteFunctionRequested: Subject<string> = new Subject<string>();
  public deleteFunctionalFailureRequested: Subject<string> = new Subject<string>();
  public deleteFailureModeRequested: Subject<string> = new Subject<string>();
  public deleteFailureMechanismRequested: Subject<string> = new Subject<string>();
  public deleteFailureMechanismReasonRequested: Subject<string> = new Subject<string>();
  public deleteFailureCauseRequested: Subject<string> = new Subject<string>();
  public deleteFailureEffectRequested: Subject<string> = new Subject<string>();
  public deletePlannedMaintenanceRequested: Subject<string> = new Subject<string>();
  public deletePlannedMaintenanceCompleted: Subject<boolean> = new Subject<boolean>();

  constructor(private modelFunctionsService: ModelFunctionsService) {}

  public functionDeleted(id: string) {
    if (this.modelFunctionsService.selectedFunction.value.id === id) {
      this.modelFunctionsService.selectedFunction.next(null);
    }

    const foundIndex: number = this.modelFunctionsService.modelFunctions.value.functions.findIndex(currentFunction => currentFunction.id === id);
    this.modelFunctionsService.modelFunctions.value.functions.splice(foundIndex, 1);
  }

  public functionalFailureDeleted(id: string) {
    if (this.modelFunctionsService.selectedFunctionalFailure.value.id === id) {
      this.modelFunctionsService.selectedFunctionalFailure.next(null);
    }

    const foundIndex: number = this.modelFunctionsService.selectedFunction.value.functionalFailures.findIndex(currentFunctionalFailure => currentFunctionalFailure.id === id);
    this.modelFunctionsService.selectedFunction.value.functionalFailures.splice(foundIndex, 1);
  }

  public failureModeDeleted(id: string) {
    const { selectedFailureMode: { value } } = this.modelFunctionsService;
    if (value && value.id === id) {
      this.modelFunctionsService.selectedFailureMode.next(null);
    }

    const foundIndex: number = this.modelFunctionsService.selectedFunctionalFailure.value.failureModes.findIndex(currentFailureMode => currentFailureMode.id === id);
    this.modelFunctionsService.selectedFunctionalFailure.value.failureModes.splice(foundIndex, 1);
    this.modelFunctionsService.failureModePatternChanged.next(null);
  }

  public failureMechanismDeleted(id: string) {
    if (this.modelFunctionsService.selectedFailureMechanism.value.id === id) {
      this.modelFunctionsService.selectedFailureMechanism.next(null);
    }

    const foundIndex: number = this.modelFunctionsService.selectedFailureMode.value.failureMechanisms.findIndex(currentFailureMechanism => currentFailureMechanism.id === id);
    this.modelFunctionsService.selectedFailureMode.value.failureMechanisms.splice(foundIndex, 1);
  }

  public failureMechanismReasonDeleted(id: string) {
    if (this.modelFunctionsService.selectedFailureMechanismReason.value.id === id) {
      this.modelFunctionsService.selectedFailureMechanismReason.next(null);
    }

    const foundIndex: number = this.modelFunctionsService.selectedFailureMechanism.value.reasons.findIndex(currentFailureMechanismReason => currentFailureMechanismReason.id === id);
    this.modelFunctionsService.selectedFailureMechanism.value.reasons.splice(foundIndex, 1);
  }

  public failureCauseDeleted(id: string) {
    if (this.modelFunctionsService.selectedFailureMechanismReason.value.id === id) {
      this.modelFunctionsService.selectedFailureMechanismReason.next(null);
    }

    const foundIndex: number = this.modelFunctionsService.selectedFailureMechanismReason.value.failureCauses.findIndex(currentFailureCause => currentFailureCause.id === id);
    this.modelFunctionsService.selectedFailureMechanismReason.value.failureCauses.splice(foundIndex, 1);
  }

  public failureEffectDeleted(id: string) {
    if (this.modelFunctionsService.selectedFailureEffect.value.id === id) {
      this.modelFunctionsService.selectedFailureEffect.next(null);
    }
    const foundIndex: number = this.modelFunctionsService.selectedFailureMode.value.failureEffects.findIndex(currentFailureEffect => currentFailureEffect.id === id);
    this.modelFunctionsService.selectedFailureMode.value.failureEffects.splice(foundIndex, 1);
  }

  public plannedMaintenanceDeleted(id: string) {
    const foundIndex = this.modelFunctionsService.selectedFunctionalFailure.value.plannedMaintenance.findIndex(currentPlannedMaintenance => currentPlannedMaintenance.id === id);
    this.modelFunctionsService.selectedFunctionalFailure.value.plannedMaintenance.splice(foundIndex, 1);

    this.removePlannedMaintenanceFromUserAcceptance(id);

    this.deletePlannedMaintenanceCompleted.next(true);
  }

  public removePlannedMaintenanceFromUserAcceptance(plannedMaintenanceId: string) {
    Array.from(this.modelFunctionsService.selectedFunctionalFailure.value.failureModes).forEach(currentFailureMode => {
      if (currentFailureMode.userAcceptance) {
        const plannedMaintenanceIndex = currentFailureMode.userAcceptance.plannedMaintenance.findIndex(x => x.id === plannedMaintenanceId);

        if (plannedMaintenanceIndex !== -1) {
          currentFailureMode.userAcceptance.plannedMaintenance.splice(plannedMaintenanceIndex, 1);
        }
      }
    });
  }
}
